import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface sobeysCom {
  bannerCode: string;
  storeId: string;
}

interface GigyaState {
  uid: string | null;
  isLoading?: boolean;
  profile: {
    firstName: string;
    lastName: string;
    email: string;
  } | null;
  loggedIn: boolean | null;
  scene?: any;
  id_token?: string | null;
  lifestyles?: Record<string, boolean> | null;
  sobeysCom?: sobeysCom | null;
  subscribed?: boolean;
  renderMemoProfile?: boolean;
}

const initialState: GigyaState = {
  uid: null,
  loggedIn: null,
  isLoading: true,
  profile: null,
  scene: null,
  id_token: null,
  lifestyles: null,
  subscribed: false,
  renderMemoProfile: false,
  sobeysCom: {
    bannerCode: "",
    storeId: "",
  },
};

const gigyaSlice = createSlice({
  name: "Gigya",
  initialState,
  reducers: {
    setLoginParams: (state, action: PayloadAction<GigyaState>) => {
      state.uid = action.payload.uid;
      state.id_token = action.payload.id_token;
      state.loggedIn = action.payload.loggedIn;
      state.isLoading = action.payload.isLoading || false;
      state.profile = action.payload.profile;
      state.scene = action.payload.scene;
      state.lifestyles = action.payload.lifestyles;
      state.sobeysCom = action.payload.sobeysCom;
      state.subscribed = action.payload.subscribed || false;
    },
    setRenderMemo: (
      state,
      action: PayloadAction<{ renderMemoProfile: boolean }>
    ) => {
      state.renderMemoProfile = action.payload.renderMemoProfile;
    },
  },
});

export const { setLoginParams, setRenderMemo } = gigyaSlice.actions;

export default gigyaSlice.reducer;
